/* eslint-disable prettier/prettier */
import {
  Avatar,
  Button,
  Drawer,
  Dropdown,
  Form,
  Layout,
  Menu,
  MenuProps,
  Modal,
  Row,
  Space,
} from "antd";
import { ReactElement, useContext, useEffect, useState } from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import logo from "../../assets/logo_1.png";
import { useTranslation } from "react-i18next";
import {
  FORM_TYPE,
  LOCAL_STORAGE_KEY,
  NOTIFICATION_TYPE,
  USER_GROUP,
} from "constants/common.constant";
import { ROUTERS } from "constants/routes.constant";
import { AiFillCaretDown } from "react-icons/ai";
import { API, Auth } from "aws-amplify";
import {
  ToastMessage,
  checkToken,
  getIdTokenFromLocalStorage,
  getRefreshTokenFromLocalStorage,
  isJsonObject,
  removeLocalDataIgnoreKey,
} from "utils/common.util";
import { TypeCommon } from "models/common";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
import "./index.css";
import { FaUsers, FaBell } from "react-icons/fa";
import ModalChangePassword from "components/modal-change-pw";
import Spinner from "components/spinner";
import FormRegister from "components/form-register";
import { customContext } from "hook/context";
import { BsMenuButtonFill } from "react-icons/bs";
import { useMediaQuery } from "react-responsive";
import { BiVector } from "react-icons/bi";
import { MdMiscellaneousServices } from "react-icons/md";
import { get, post, put } from "api/base";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { IoMdLink } from "react-icons/io";
// import uat from "../../assets/uat.png";

const MainLayout = (): ReactElement => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    listOrg,
    getList,
    userServices,
    getUserDetail,
    resetUser,
    forceChangePassword,
    resetForceChangePassword,
  } = useContext(customContext);
  const isMobile = useMediaQuery({ query: "(max-width: 1200px)" });
  const location = useLocation().pathname;
  const { Content, Sider } = Layout;

  // Detect if device is mobile (phone/tablet) or desktop/laptop
  const isMobileDevice = (): boolean => {
    const userAgent = navigator.userAgent.toLowerCase();
    return (
      /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
        userAgent,
      ) || window.innerWidth <= 768
    );
  };
  const [form] = Form.useForm<TypeCommon>();
  const [formUpdate] = Form.useForm<TypeCommon>();
  const [formPreview] = Form.useForm<TypeCommon>();
  const userInfo =
    isJsonObject(localStorage.getItem(LOCAL_STORAGE_KEY.USER_INFO)) &&
    JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY.USER_INFO) as string);
  const redirect = localStorage.getItem(LOCAL_STORAGE_KEY.REDIRECT);
  const [disableMenu, setDisableMenu] = useState<boolean>(false);
  const [isEmailExist, setIsEmailExist] = useState<boolean>(false);
  const menuItems = [
    {
      key: ROUTERS.USER_MANAGEMENT,
      label: (
        <Link className="link flex items-center" to={ROUTERS.USER_MANAGEMENT}>
          <FaUsers className="text-[20px] mr-2" />
          {t("dashboard.button2")}
        </Link>
      ),
    },
    {
      key: ROUTERS.SERVICE_MANAGEMENT,
      label: (
        <Link
          className="link flex items-center"
          to={ROUTERS.SERVICE_MANAGEMENT}
        >
          <MdMiscellaneousServices className="text-[20px] mr-2" />
          サービス管理
        </Link>
      ),
    },
    {
      key: ROUTERS.LINK_MANAGEMENT,
      label: (
        <Link className="link flex items-center" to={ROUTERS.LINK_MANAGEMENT}>
          <IoMdLink className="text-[20px] mr-2" />
          ユーザー招待
        </Link>
      ),
      disabled: !(
        userInfo?.group === USER_GROUP.PLATFORM_ADMIN ||
        userInfo?.group === USER_GROUP.ADMIN ||
        userInfo?.username === "t012" ||
        userInfo?.username === "t045" ||
        userInfo?.username === "t082" ||
        userInfo?.username === "t081"
      ),
    },
    {
      key: ROUTERS.ORGANIZATION_LIST,
      label: (
        <Link className="link flex items-center" to={ROUTERS.ORGANIZATION_LIST}>
          <BiVector className="text-[20px] mr-2" />
          組織管理
        </Link>
      ),
      disabled: !(
        userInfo?.group === USER_GROUP.PLATFORM_ADMIN ||
        userInfo?.group === USER_GROUP.ADMIN ||
        localStorage.getItem(LOCAL_STORAGE_KEY.LOGIN_DEVICE) === "azure"
      ),
    },
    {
      key: ROUTERS.NOTIFICATION_SETTING,
      label: (
        <Link
          className="link flex items-center"
          to={ROUTERS.NOTIFICATION_SETTING}
        >
          <FaBell className="text-[20px] mr-2" />
          通知設定
        </Link>
      ),
      disabled:
        userInfo?.group !== USER_GROUP.PLATFORM_ADMIN &&
        userInfo?.group !== USER_GROUP.ADMIN,
    },
  ];
  const [menuList, setMenuList] = useState<TypeCommon>(menuItems);
  const [current, setCurrent] = useState<string>(ROUTERS.APPROVE);
  const [openKey, setOpenKey] = useState<TypeCommon>([
    ROUTERS.SERVICE_MANAGEMENT,
  ]);
  const [isExpired, setIsExpired] = useState<boolean>(false);
  const [serviceIds, setServiceIds] = useState<TypeCommon>([
    ROUTERS.SERVICE_MANAGEMENT,
  ]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isFetchDetail, setIsFetchDetail] = useState<boolean>(false);
  const [collapsed, setCollapsed] = useState(false);
  const [isOpenModalChangePw, setIsOpenModalChangePw] =
    useState<boolean>(false);
  const [currentUser, setCurrentUser] = useState<TypeCommon>();
  const [listOrgs, setListOrgs] = useState<TypeCommon>([]);
  const [isOpenModalPreview, setIsOpenModalPreview] = useState<boolean>(false);
  const [isOpenModalUpdateUser, setIsOpenModalUpdateUser] =
    useState<boolean>(false);
  const [serviceListForUpdate, setServiceListForUpdate] = useState<TypeCommon>(
    [],
  );

  useEffect(() => {
    const checkForChange = (): void => {
      const current = localStorage.getItem(LOCAL_STORAGE_KEY.USER_INFO);
      const currentData =
        current && isJsonObject(current) && JSON.parse(current);
      if (currentData?.username !== userInfo?.username) {
        window.location.reload(); // Gọi hành động khi thay đổi
      }
    };

    const interval = setInterval(checkForChange, 1000);
    return () => clearInterval(interval);
  }, []);

  const getWindowDimensions = (): TypeCommon => {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  };
  const [windowDimensions, setWindowDimensions] = useState<TypeCommon>(
    getWindowDimensions(),
  );
  const items: MenuProps["items"] = [
    // {
    //   label: t("header.change-password"),
    //   key: "0",
    // },
    {
      label: "ユーザー管理",
      key: "1",
    },
    // {
    //   label: t("header.logout"),
    //   key: "2",
    // },
  ];
  const confirm = (): TypeCommon => {
    Modal.info({
      title: t("button.confirm"),
      // icon: <ExclamationCircleFilled className="!text-[#1677ff]" />,
      content: "1時間以上操作しないので自動的にログアウトされました。",
      okText: t("button.confirm"),
      // okText: t("button.yes"),
      // cancelText: t("button.no"),
      onOk() {
        logout();
      },
      centered: true,
      closable: false,
    });
  };

  const confirmLogout = (): TypeCommon => {
    Modal.confirm({
      title: t("button.confirm"),
      icon: <ExclamationCircleFilled className="!text-[#1677ff]" />,
      content: "ログアウトしても宜しいでしょうか。",
      okText: t("button.yes"),
      cancelText: t("button.no"),
      onOk() {
        logout();
      },
      centered: true,
      closable: false,
    });
  };
  useEffect(() => {
    if (
      location !== ROUTERS.APPROVE &&
      location !== ROUTERS.DETAIL_FORM &&
      location !== ROUTERS.SUPPERLIER_SCREEN_INPUT_FORM &&
      location !== ROUTERS.PHOTOGRAPHING_DOCUMENT
    ) {
      sessionStorage.removeItem(LOCAL_STORAGE_KEY.SEARCH_CONDITIONS);
    }
    if (location === ROUTERS.SERVICE_MANAGEMENT) {
      getUserDetail();
    }
    setCollapsed(false);
  }, [location]);
  const fetchUserDetailData = async (): Promise<void> => {
    try {
      setIsFetchDetail(true);
      const serviceList: TypeCommon = [];
      let isForm = false;
      // let serviceFormId = "";
      // let serviceTokubaiId = "";
      if (userServices?.length > 0) {
        setDisableMenu(false);
        const ownerIds: string[] = [];
        userServices?.forEach((item: TypeCommon, index: number) => {
          if (item?.is_active) {
            //koji
            if (item?.type === "form") {
              isForm = true;
              // serviceFormId = item?.id;
            }
            ownerIds?.push(item?.id);
            serviceList.push({
              key: `${item?.url}?index=${index}`,
              label: (
                <Link
                  className="link flex items-center"
                  target={`${item?.type === "form" ? "" : "_blank"}`}
                  to={item?.url}
                  onClick={(e) => {
                    e.preventDefault();
                    handleServiceClick(item);
                  }}
                >
                  {!item?.release_status && (
                    <span className="text-white !text-[12.5px] mr-2 bg-[#fadb14] !px-[8px] !rounded !h-[20px] flex items-center justify-center">
                      UAT
                    </span>
                  )}
                  <span className="truncate max-w-full">{item?.name}</span>
                </Link>
              ),
              serviceid: item?.id,
              release_status: item?.release_status,
            });
          }
        });
        setServiceIds(ownerIds);
        // Check if userInfo.name matches pattern: starts with 't' followed by number > 100
        const isValidUserName =
          userInfo?.username &&
          /^s\d+$/.test(userInfo?.username) &&
          Number.parseInt(userInfo?.username?.substring(1), 10) > 100;

        if (
          isForm &&
          !redirect &&
          location === ROUTERS.SERVICE_MANAGEMENT &&
          // !userInfo?.is_tokubai &&
          userInfo?.group !== USER_GROUP.PLATFORM_ADMIN &&
          isValidUserName
        ) {
          navigate(ROUTERS.APPROVE);
          localStorage.setItem(LOCAL_STORAGE_KEY.REDIRECT, isForm);
        }
        if (
          serviceList?.length === 0 &&
          userInfo?.group !== USER_GROUP.PLATFORM_ADMIN
        ) {
          setDisableMenu(true);
        }
        serviceList.sort((a: TypeCommon, b: TypeCommon) => {
          if (a.release_status !== b.release_status) {
            return Number(b.release_status) - Number(a.release_status);
          }
          if (a.release_status === true) {
            return a.serviceid - b.serviceid;
          }
          return 0;
        });
        // serviceList?.sort(
        //   (a: TypeCommon, b: TypeCommon) => a?.serviceid - b?.serviceid,
        // );
        // const newServiceListTokubai = serviceList?.filter(
        //   (item: TypeCommon) => item?.serviceid !== serviceFormId,
        // );
        // const newServiceListKoji =
        //   userInfo?.group !== USER_GROUP.PLATFORM_ADMIN
        //     ? serviceList?.filter(
        //         (item: TypeCommon) => item?.serviceid !== serviceTokubaiId,
        //       )
        //     : serviceList;
        // const listChilren = userInfo?.is_tokubai
        //   ? newServiceListTokubai
        //   : serviceList;
        const listChilren = serviceList;
        const index = menuList.findIndex(
          (el: TypeCommon) => el.key === ROUTERS.SERVICE_MANAGEMENT,
        );
        if (index > -1) {
          menuList[index] = {
            key: ROUTERS.SERVICE_MANAGEMENT,
            label: (
              <Link
                className="link flex items-center"
                to={ROUTERS.SERVICE_MANAGEMENT}
              >
                <MdMiscellaneousServices className="text-[20px] mr-2" />
                サービス管理
              </Link>
            ),
            children: listChilren?.length > 0 ? listChilren : false,
          };
          setMenuList([...menuList]);
        }
      } else {
        if (userInfo?.group !== USER_GROUP.PLATFORM_ADMIN) setDisableMenu(true);
        setServiceIds([]);
      }
      setIsFetchDetail(false);
    } catch (error: TypeCommon) {
      setIsFetchDetail(false);
      ToastMessage(NOTIFICATION_TYPE.ERROR, t("alert-message.failure"));
    }
  };
  useEffect(() => {
    fetchUserDetailData();
  }, [userServices]);
  const logout = async (): Promise<void> => {
    try {
      await Auth.signOut();
      removeLocalDataIgnoreKey([LOCAL_STORAGE_KEY.LIST_USER]);
      sessionStorage.clear();
      resetUser();
      resetForceChangePassword();
      navigate(ROUTERS.LOGIN);
    } catch (error) {
      ToastMessage(NOTIFICATION_TYPE.ERROR, t("alert-message.failure"));
    }
  };
  const getNewRefreshToken = async (): Promise<void> => {
    try {
      const res = await get("login", "/login/refresh", {
        username: userInfo?.username,
      });

      // Cập nhật refresh_token vào localStorage của Cognito
      const CLIENT_ID = "ke60sjpuo295i99e9j2n594q0";
      const USERNAME = res?.username || userInfo?.username;
      if (res?.refresh_token && USERNAME) {
        localStorage.setItem(
          `CognitoIdentityServiceProvider.${CLIENT_ID}.${USERNAME}.refreshToken`,
          res.refresh_token,
        );
      }

      localStorage.setItem(LOCAL_STORAGE_KEY.REFRESH_TOKEN, res.refresh_token);

      const issuedAt = Date.now();
      const expiresAt = issuedAt + 30 * 24 * 60 * 60 * 1000; // Cognito default = 30 ngày
      localStorage.setItem(
        LOCAL_STORAGE_KEY.REFRESH_EXPIRES_AT,
        expiresAt.toString(),
      );
    } catch (error: TypeCommon) {
      setIsLoading(false);
      ToastMessage(NOTIFICATION_TYPE.ERROR, t("alert-message.failure"));
    }
  };
  const checkRefreshToken = (): void => {
    const expiresAtStr = localStorage.getItem(
      LOCAL_STORAGE_KEY.REFRESH_EXPIRES_AT,
    );
    const expiresAt = expiresAtStr ? parseInt(expiresAtStr, 10) : 0;
    const now = Date.now();

    const ONE_DAY = 24 * 60 * 60 * 1000;

    if (expiresAt - now < ONE_DAY) {
      getNewRefreshToken();
    }
  };
  useEffect(() => {
    const refreshToken = localStorage.getItem(LOCAL_STORAGE_KEY.REFRESH_TOKEN);
    const userToken = localStorage.getItem(LOCAL_STORAGE_KEY.USER_TOKEN);
    if (!userToken) {
      const userTokenAws = getIdTokenFromLocalStorage();
      if (userTokenAws)
        localStorage.setItem(LOCAL_STORAGE_KEY.USER_TOKEN, userTokenAws);
    }
    if (refreshToken) {
      const isAzure =
        localStorage.getItem(LOCAL_STORAGE_KEY.LOGIN_DEVICE) === "azure";
      if (isAzure) checkRefreshToken();
    } else {
      const refreshTokenAws = getRefreshTokenFromLocalStorage();
      if (refreshTokenAws)
        localStorage.setItem(LOCAL_STORAGE_KEY.REFRESH_TOKEN, refreshTokenAws);
      else getNewRefreshToken();
    }
  }, []);
  const getStoredExpireTimestamp = (key: string): number | null => {
    const storedExpireTime = localStorage.getItem(key);
    if (!storedExpireTime) {
      return null;
    }

    const expireTimestamp = Number(storedExpireTime);
    return Number.isFinite(expireTimestamp) ? expireTimestamp : null;
  };
  const isIdleSessionExpired = (): boolean => {
    const now = Date.now();
    const lastExpireTimestamp = getStoredExpireTimestamp(
      LOCAL_STORAGE_KEY.LAST_EXPIRE_TIME,
    );
    const expireTimestamp = getStoredExpireTimestamp(
      LOCAL_STORAGE_KEY.EXPIRE_TIME,
    );

    if (lastExpireTimestamp !== null && lastExpireTimestamp <= now) {
      return true;
    }

    return expireTimestamp !== null && expireTimestamp <= now;
  };
  const checkForInactivity = (): void => {
    if (isIdleSessionExpired()) {
      setIsExpired(true);
    }
  };
  const updateExpireTime = (): void => {
    if (isIdleSessionExpired()) {
      return;
    }

    const isAzure =
      localStorage.getItem(LOCAL_STORAGE_KEY.LOGIN_DEVICE) === "azure";
    const expireTime: TypeCommon = isAzure
      ? Date.now() + 30 * 24 * 60 * 60 * 1000
      : Date.now() + 3600000;
    localStorage.setItem(LOCAL_STORAGE_KEY.EXPIRE_TIME, expireTime);
  };
  const saveExpireTime = (): void => {
    const expireTime: TypeCommon = localStorage.getItem(
      LOCAL_STORAGE_KEY.EXPIRE_TIME,
    );
    localStorage.setItem(LOCAL_STORAGE_KEY.LAST_EXPIRE_TIME, expireTime);
  };
  const getListService = async (): Promise<void> => {
    try {
      setIsLoading(true);
      const res = await get("service", "/service/list");
      if (res?.data) {
        const newList = res?.data?.data?.map((item: TypeCommon) => {
          return {
            value: item?.id,
            label: item?.name,
            ownersRoot: item?.owners_root,
          };
        });
        setServiceListForUpdate(newList);
      }
    } catch (error: TypeCommon) {
      checkToken();
      ToastMessage(NOTIFICATION_TYPE.ERROR, t("alert-message.failure"));
    } finally {
      setIsLoading(false);
    }
  };
  const handleClickUpdateInfo = async (): Promise<void> => {
    await getListService();
    setCurrentUser({
      ...userInfo,
      services:
        userInfo?.services?.length > 0
          ? userInfo?.services
          : userInfo?.owner_services,
    });
    setIsOpenModalUpdateUser(true);
  };
  const handleMenuClick: MenuProps["onClick"] = (e) => {
    if (e.key === "2") {
      confirmLogout();
    } else if (e.key === "0") {
      setIsOpenModalChangePw(true);
    } else {
      handleClickUpdateInfo();
    }
  };
  // const getRefreshToken = async (): Promise<TypeCommon> => {
  //   try {
  //     const session = await Auth.currentSession();
  //     const refreshToken = session.getRefreshToken().getToken();
  //     const currentToken = localStorage.getItem(
  //       LOCAL_STORAGE_KEY.REFRESH_TOKEN,
  //     );
  //     if (refreshToken !== currentToken) {
  //       localStorage.setItem(LOCAL_STORAGE_KEY.REFRESH_TOKEN, refreshToken);
  //     }
  //   } catch (err) {
  //     return "";
  //   }
  // };
  // useEffect(() => {
  //   getRefreshToken();
  // }, []);
  useEffect(() => {
    if (isExpired) {
      removeLocalDataIgnoreKey([
        LOCAL_STORAGE_KEY.LIST_USER,
        LOCAL_STORAGE_KEY.USER_INFO,
      ]);
      sessionStorage.clear();
      resetForceChangePassword();
      confirm();
    }
  }, [isExpired]);
  useEffect(() => {
    const syncInactivityState = (): void => {
      if (isIdleSessionExpired()) {
        setIsExpired(true);
        return;
      }

      localStorage.removeItem(LOCAL_STORAGE_KEY.LAST_EXPIRE_TIME);
    };

    const handleVisibilityChange = (): void => {
      if (document.visibilityState === "visible") {
        syncInactivityState();
      }
    };

    syncInactivityState();

    const interval = setInterval(() => {
      checkForInactivity();
    }, 1000);
    window.addEventListener("pageshow", syncInactivityState);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      clearInterval(interval);
      window.removeEventListener("pageshow", syncInactivityState);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);
  useEffect(() => {
    if (forceChangePassword) {
      setIsOpenModalChangePw(true);
    }
  }, [forceChangePassword]);

  useEffect(() => {
    getList();
    if (location !== ROUTERS.SERVICE_MANAGEMENT) getUserDetail();
    const handleResize = (): void => {
      setWindowDimensions(getWindowDimensions());
    };

    window.addEventListener("resize", handleResize);
    window.addEventListener("click", updateExpireTime);
    window.addEventListener("keypress", updateExpireTime);
    window.addEventListener("scroll", updateExpireTime, true);
    window.addEventListener("mousemove", updateExpireTime);
    window.addEventListener("beforeunload", saveExpireTime);
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("click", updateExpireTime);
      window.removeEventListener("keypress", updateExpireTime);
      window.removeEventListener("scroll", updateExpireTime, true);
      window.removeEventListener("mousemove", updateExpireTime);
      window.removeEventListener("beforeunload", saveExpireTime);
    };
  }, []);
  const onClick: MenuProps["onClick"] = (e) => {
    setCurrent(e.key);
  };
  useEffect(() => {
    if (listOrg?.length > 0) {
      setListOrgs(listOrg);
    }
  }, [listOrg]);
  useEffect(() => {
    menuList.forEach((item: TypeCommon) => {
      if (item.key === location) setCurrent(item.key);
      else if (item.children) {
        const pathChild = item.children.filter((el: TypeCommon) =>
          el.key?.includes(location),
        );
        if (pathChild?.length > 0) setCurrent(pathChild[0].key);
      }
    });

    // Khi location là "/" thì active menu SERVICE_MANAGEMENT
    if (location === "/") {
      setCurrent(ROUTERS.SERVICE_MANAGEMENT);
    }
  }, [location, menuList, isFetchDetail]);
  const handleChangePassword = async (): Promise<void> => {
    try {
      setIsLoading(true);
      const newPassword = form.getFieldValue("newPassword").trim();
      await API.post("verify", "/verify/change-password", {
        body: {
          username: userInfo?.username,
          password: newPassword,
          admin_key: "d511cbe6-6585-4c12-ae1d-a5788deeeddb",
        },
      });
      setIsOpenModalChangePw(false);
      form.resetFields();
      await getUserDetail();
      setIsLoading(false);
      ToastMessage(NOTIFICATION_TYPE.SUCCESS, "パスワードを変更しました。");
    } catch (err: TypeCommon) {
      setIsLoading(false);
      ToastMessage(
        NOTIFICATION_TYPE.ERROR,
        err?.response?.data?.message || t("alert-message.failure"),
      );
    }
  };
  const checkUserExist = async (searchString: string): Promise<TypeCommon> => {
    try {
      if (searchString) {
        const res = await API.get("public", "/check-exist-user", {
          queryStringParameters: {
            search: searchString,
          },
        });
        if (res?.data?.data) {
          setIsEmailExist(true);
          document?.getElementById("email")?.scrollIntoView({
            behavior: "smooth",
            block: "end",
            inline: "nearest",
          });
          return true;
        }
        setIsEmailExist(false);
        return false;
      }
    } catch (error: TypeCommon) {
      return;
    }
  };
  const onUpdateUser = async (): Promise<void> => {
    try {
      setIsLoading(true);
      let isUpdateEmail = false;
      const phoneNumber = formUpdate.getFieldValue("phoneNumber");
      const email = formUpdate.getFieldValue("email");
      const attributes = {
        phone_number: `+81${phoneNumber.slice(1, phoneNumber?.length)}`,
        first_name: formUpdate.getFieldValue("firstName"),
        first_name_yomi: formUpdate.getFieldValue("firstName_yomi"),
        last_name: formUpdate.getFieldValue("lastName"),
        last_name_yomi: formUpdate.getFieldValue("lastName_yomi"),
      };
      if (email !== currentUser?.email) {
        isUpdateEmail = true;
        Object.assign(attributes, {
          email,
        });
        const checkExistEmail = await checkUserExist(email);
        if (!checkExistEmail) {
          await put("user", "/user/update", {
            user_id: currentUser?.sub,
            attributes,
          });
        } else {
          setIsOpenModalPreview(false);
          setIsLoading(false);
          return;
        }
      } else {
        await put("user", "/user/update", {
          user_id: currentUser?.sub,
          attributes,
        });
      }
      localStorage.setItem(
        LOCAL_STORAGE_KEY.USER_INFO,
        JSON.stringify({
          ...userInfo,
          first_name: formUpdate.getFieldValue("firstName"),
          last_name: formUpdate.getFieldValue("lastName"),
          first_name_yomi: formUpdate.getFieldValue("firstName_yomi"),
          last_name_yomi: formUpdate.getFieldValue("lastName_yomi"),
          email,
          phone_number: `+81${phoneNumber.slice(1, phoneNumber?.length)}`,
        }),
      );
      await getUserDetail();
      setIsLoading(false);
      setIsOpenModalPreview(false);
      setIsOpenModalUpdateUser(false);
      if (isUpdateEmail) {
        if (
          userInfo?.group !== USER_GROUP.PLATFORM_ADMIN &&
          userInfo?.group !== USER_GROUP.ADMIN
        ) {
          ToastMessage(
            NOTIFICATION_TYPE.INFO,
            "新しメールアドレスに確認リンクが送信されました。リンクをクリックするとメールアドレスが変更できる。",
          );
        } else
          ToastMessage(
            NOTIFICATION_TYPE.SUCCESS,
            "ユーザー情報を変更しました。",
          );
      } else {
        ToastMessage(NOTIFICATION_TYPE.SUCCESS, "ユーザー情報を変更しました。");
      }
    } catch (err: TypeCommon) {
      setIsLoading(false);
      ToastMessage(NOTIFICATION_TYPE.ERROR, t("alert-message.failure"));
    }
  };
  const handleBrowserConfirm = (
    browserType: string,
    selectedService: TypeCommon,
  ): void => {
    const storeCode = userInfo?.organization_code ?? "000";
    const deviceNum = `iPhone${storeCode}01`;
    const targetUrl = `${selectedService?.url}?cd_tenpo=${storeCode}&device_num=${deviceNum}`;

    if (browserType === "asbrowser") {
      const startTime = Date.now();
      window.location.href = `asbrowser://?url=${targetUrl}`;

      // Kiểm tra sau 300ms nếu không chuyển màn hình
      setTimeout(() => {
        if (Date.now() - startTime < 300) {
          // Nếu không có chuyển hướng (không có handler cho custom scheme)
          ToastMessage(
            NOTIFICATION_TYPE.ERROR,
            "AsBrowserアプリがインストールされていません。",
          );
        }
      }, 200);
    } else if (browserType === "safari") {
      if (isMobileDevice()) {
        window.location.assign(targetUrl);
      } else {
        window.open(targetUrl, "_blank");
      }
    }
  };

  const handleRedirect = async (item: TypeCommon): Promise<void> => {
    const userToken = getIdTokenFromLocalStorage();
    const refreshToken = getRefreshTokenFromLocalStorage();

    if (item?.is_summit_service) {
      if (isMobileDevice() || item?.url.includes("tokubaiassist")) {
        window.location.assign(item?.url);
      } else {
        window.open(item?.url, "_blank");
      }
      return;
    }

    try {
      setIsLoading(true);
      const body = {
        user_token: userToken,
        refresh_token: refreshToken,
        id_token: userToken,
        url: item?.url.startsWith("http")
          ? item?.url
          : `https://${window.location.host}${item?.url}`,
        code_verifier: "",
      };

      const res = await post("auth", "/auth/authorize", body);

      const redirectUrl =
        res?.data?.redirect_url || res?.data?.data?.redirect_url;
      if (redirectUrl) {
        if (isMobileDevice()) {
          window.location.assign(redirectUrl);
        } else {
          window.open(redirectUrl, "_blank");
        }
      }
    } catch (err) {
      ToastMessage(NOTIFICATION_TYPE.ERROR, t("alert-message.failure"));
    } finally {
      setIsLoading(false);
    }
  };

  const handleServiceClick = (item: TypeCommon): void => {
    if ("Notification" in window) {
      localStorage.setItem(
        LOCAL_STORAGE_KEY.NOTIFICATION_PERMISIION,
        Notification?.permission,
      );
    }

    if (item?.type !== "form") {
      if (item?.url.includes("app-nebiki")) {
        Modal.info({
          title: t("button.confirm"),
          content: (
            <div className="flex flex-col gap-4">
              <p>使用するブラウザを選択してください。</p>
              <div className="flex items-center justify-center gap-2">
                <Button
                  className="!bg-[#1677ff] !text-white hover:opacity-80"
                  onClick={(): void => {
                    handleBrowserConfirm("safari", item);
                    Modal.destroyAll();
                  }}
                  type="primary"
                >
                  サファリ
                </Button>
                <Button
                  className="!bg-[#1677ff] !text-white hover:opacity-80"
                  onClick={(): void => {
                    handleBrowserConfirm("asbrowser", item);
                    // Modal.destroyAll();
                  }}
                  type="primary"
                >
                  AsBrowser
                </Button>
              </div>
            </div>
          ),
          centered: true,
          closable: true,
          footer: null,
          // okText: "キャンセル",
          // onOk: (): void => {
          //   setSelectedService(undefined);
          //   Modal.destroyAll();
          // },
        });
      } else {
        handleRedirect(item);
      }
    } else {
      navigate(item?.url);
    }
  };
  return (
    <>
      {(isLoading || isFetchDetail) && <Spinner isFullWidth={true} />}
      <Layout>
        <Row
          className={`w-full px-5 h-[60px] flex items-center justify-between bg-[#eaecf1cc] z-10 shadow-lg border-b border-b-[#00000080]`}
        >
          <Row className="flex items-center justify-between">
            <img
              src={logo}
              alt=""
              className="w-[35px] h-[35px] md:w-[50px] md:h-[50px] cursor-pointer"
              onClick={(): void => {
                window.location.reload();
              }}
            />
            <Row className="flex-col justify-center items-center ml-2 hidden sm:flex">
              <Row className="text-[12px] lg:text-[18px] font-semibold text-gray-700">
                サミット アシスト
              </Row>
            </Row>
          </Row>
          <Row className="flex items-center">
            <div
              onClick={confirmLogout}
              className="mr-5 text-blue-500 cursor-pointer hover:opacity-50"
            >
              ユーザー切替
            </div>
            <Dropdown
              menu={{
                items,
                onClick: handleMenuClick,
              }}
              trigger={["click"]}
            >
              <a
                onClick={(e): void => e.preventDefault()}
                className="hover:!text-black hover:opacity-80"
              >
                <Space>
                  <Avatar
                    style={{
                      backgroundColor: "#79AF7C",
                    }}
                    size={32}
                    className="flex items-center justify-center"
                  >
                    <span className="text-[14px] font-semibold uppercase">
                      {userInfo?.username?.slice(0, 2)}
                    </span>
                  </Avatar>
                  <span className="hidden md:block text-ellipsis overflow-hidden max-w-[300px]">
                    {userInfo?.username}
                  </span>
                  <AiFillCaretDown className="ml-1 lg:ml-5 text-[14px]" />
                </Space>
              </a>
            </Dropdown>
            {isMobile && !disableMenu && (
              <BsMenuButtonFill
                onClick={(): void => setCollapsed(true)}
                className="text-[20px] ml-5 text-[#0b5ed7] cursor-pointer"
              />
            )}
          </Row>
        </Row>
        <Layout>
          {isMobile ? (
            <Drawer
              title="Basic Drawer"
              placement="right"
              onClose={(): void => {
                setCollapsed(false);
              }}
              open={collapsed}
              width={250}
            >
              <Sider
                width={250}
                className="!bg-[#eaecf1cc] menu-container-mobile px-3 py-5 border-r z-20 border-r-[#00000080]"
              >
                <Menu
                  mode="inline"
                  className="!w-full !h-full !border-none font-[600] text-[15px] !bg-[#eaecf1cc]"
                  selectedKeys={[current]}
                  openKeys={openKey}
                  onOpenChange={(openKeys): void => setOpenKey(openKeys)}
                  items={menuList}
                  onClick={onClick}
                />
              </Sider>
            </Drawer>
          ) : (
            <Sider
              width={250}
              className={`!bg-[#eaecf1cc] menu-container px-3 py-5 border-r z-20 border-r-[#00000080] ${
                disableMenu ? "disable-menu" : ""
              }`}
            >
              <Menu
                mode="inline"
                className="!w-full !h-full !border-none font-[600] text-[15px] !bg-[#eaecf1cc]"
                selectedKeys={[current]}
                openKeys={openKey}
                onOpenChange={(openKeys): void => setOpenKey(openKeys)}
                items={menuList}
                onClick={onClick}
              />
            </Sider>
          )}
          <SimpleBar
            style={{
              height: "calc(100dvh - 60px)",
              width: "100%",
            }}
          >
            <Layout
              style={{
                padding: 0,
                minHeight: "100%",
                overflowY: "hidden",
              }}
              className="custom-layout"
            >
              <Content
                style={{
                  padding: "10px 20px",
                  margin: 0,
                  background: "#fff",
                  minHeight: "100%",
                  overflow: "auto",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Outlet context={[serviceIds, isFetchDetail]} />
              </Content>
            </Layout>
          </SimpleBar>
        </Layout>
      </Layout>
      {isOpenModalChangePw && (
        <ModalChangePassword
          form={form}
          open={isOpenModalChangePw}
          handleCancel={(): void => {
            form.resetFields();
            setIsOpenModalChangePw(false);
          }}
          handleConfirm={handleChangePassword}
          forceOpen={forceChangePassword}
        />
      )}
      {isOpenModalUpdateUser && (
        <Modal
          title={`ユーザー管理`}
          centered
          maskClosable={false}
          open={isOpenModalUpdateUser}
          onCancel={(): void => {
            setIsOpenModalUpdateUser(false);
            setIsEmailExist(false);
          }}
          onOk={(): void => formUpdate.submit()}
          className="modal-update-info modal-custom"
          cancelText={t("button.cancel")}
          okText={t("button.next")}
        >
          <SimpleBar
            style={{
              height:
                windowDimensions?.height > 800
                  ? "500px"
                  : windowDimensions?.height - 200,
              width: "100%",
              padding: "0 24px",
            }}
          >
            <FormRegister
              form={formUpdate}
              userData={currentUser}
              onSubmit={(): void => {
                formPreview.setFieldsValue({
                  firstName: formUpdate.getFieldValue("firstName"),
                  lastName: formUpdate.getFieldValue("lastName"),
                  firstName_yomi: formUpdate.getFieldValue("firstName_yomi"),
                  lastName_yomi: formUpdate.getFieldValue("lastName_yomi"),
                  userName: formUpdate.getFieldValue("userName"),
                  email: formUpdate.getFieldValue("email"),
                  phoneNumber: formUpdate.getFieldValue("phoneNumber"),
                  role: formUpdate.getFieldValue("role"),
                  org: formUpdate.getFieldValue("org"),
                  services: formUpdate.getFieldValue("services"),
                });
                setIsOpenModalPreview(true);
              }}
              formType={FORM_TYPE.USER_UPDATE}
              isEmailExist={isEmailExist}
              setIsEmailExist={setIsEmailExist}
              listAllOrg={listOrgs}
              serviceIds={serviceIds}
              serviceList={serviceListForUpdate}
            />
          </SimpleBar>
        </Modal>
      )}
      {isOpenModalPreview && (
        <Modal
          title={`ユーザー管理`}
          centered
          maskClosable={false}
          open={isOpenModalPreview}
          onCancel={(): void => {
            setIsOpenModalPreview(false);
          }}
          onOk={(): void => formPreview.submit()}
          className="modal-update-info modal-custom"
          cancelText={t("button.cancel")}
          okText={"更新"}
        >
          <SimpleBar
            style={{
              height:
                windowDimensions?.height > 800
                  ? "500px"
                  : windowDimensions?.height - 200,
              width: "100%",
              padding: "0 24px",
            }}
          >
            <FormRegister
              form={formPreview}
              isPreview
              onSubmit={onUpdateUser}
              listAllOrg={listOrgs}
              serviceList={serviceListForUpdate}
              serviceIds={serviceIds}
            />
          </SimpleBar>
        </Modal>
      )}
    </>
  );
};

export default MainLayout;
